import { useState } from "react";
import { ChevronsUpDown, Check } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Command, CommandEmpty, CommandInput, CommandItem, CommandList } from "./ui/command";

// Searchable dropdown; options: [{ id, name, sku? }]. noneLabel adds a "clear" option that sends "".
export default function SearchSelect({ value, onChange, options, testId, placeholder, noneLabel, searchPlaceholder = "Search name or SKU…", className = "" }) {
  const [open, setOpen] = useState(false);
  const cur = options.find((o) => o.id === value);
  const pick = (v) => { onChange(v); setOpen(false); };
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" role="combobox" data-testid={testId}
          className={`w-full h-12 px-3 flex items-center justify-between gap-2 rounded-md bg-[#090D16] border border-[#334155] text-sm text-left ${className}`}>
          <span className={`truncate ${cur ? "" : "text-[#6B7280]"}`}>{cur ? <>{cur.name}{cur.sku && <span className="text-[#6B7280] font-mono text-xs"> · {cur.sku}</span>}</> : (noneLabel && !value ? noneLabel : placeholder)}</span>
          <ChevronsUpDown className="w-4 h-4 shrink-0 text-[#6B7280]" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="p-0 w-[--radix-popover-trigger-width] min-w-[280px] bg-[#172033] border-[#334155]" align="start">
        <Command className="bg-transparent">
          <CommandInput data-testid={`${testId}-search`} placeholder={searchPlaceholder} />
          <CommandList className="max-h-72">
            <CommandEmpty>No matches.</CommandEmpty>
            {noneLabel && (
              <CommandItem value={`__none__ ${noneLabel}`} data-testid={`${testId}-option-none`} onSelect={() => pick("")}>
                <Check className={`w-4 h-4 ${!value ? "opacity-100" : "opacity-0"}`} /><span className="text-[#9CA3AF]">{noneLabel}</span>
              </CommandItem>
            )}
            {options.map((o) => (
              <CommandItem key={o.id} value={`${o.name} ${o.sku || ""} ${o.id}`} data-testid={`${testId}-option-${o.sku || o.id}`} onSelect={() => pick(o.id)}>
                <Check className={`w-4 h-4 ${o.id === value ? "opacity-100" : "opacity-0"}`} />
                {o.name}{o.sku && <span className="text-[#6B7280] font-mono text-xs"> · {o.sku}</span>}
              </CommandItem>
            ))}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
